import { DataGrid } from '@tableau/data-grid-1-wrapper';
import * as _ from 'underscore';

import { CommonStyles } from './CommonStyles';

export module CommonDataGridColumns {
  export function withExtraSpace(originalColumn: DataGrid.Column){
    return _.extend({},
      originalColumn,
      {
        preferredWidth: CommonStyles.Sizes.ColMaxWidth // If there is leftover space the column will expand up to this size)
      });
  }
}
